











import { Component, Vue } from 'vue-property-decorator'; 
import {mapState} from 'vuex'
import { Action } from 'vuex-class' 
import Header from '@/components/WineBox/Header.vue'
import Itens from '@/components/WineBox/Itens.vue' 
import SubTotal from '@/components/WineBox/SubTotal.vue' 

@Component({
  components: {
  Header, Itens, SubTotal
  },
  computed: mapState([ 
    'carrinho','wineBox',
  ]),

  
})
export default class WineBox extends Vue {
    @Action('TOGGLE_WINEBOX')
    TOGGLE_WINEBOX!: (TOGGLE_WINEBOX: void) => void 

    toggleWineBox(){
        this.TOGGLE_WINEBOX()
    }
}
